import { Grid, GridItem } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { FieldsContainer } from '@mews-commander/ui';
import { InputField, CurrentEnterpriseCurrencySelectField } from '@mews-commander/legacy-form';
import CreditRatingField from './CreditRatingField';

const creditLimitProps = {
    label: <LocalizedText textKey={TextKey.CreditLimit} />,
    name: 'value',
};

const currencySelectFieldProps = {
    label: <LocalizedText textKey={TextKey.Currency} />,
    name: 'currencyCode',
};

const CreditLimitFields = () => (
    <FieldsContainer>
        <Grid
            templateColumns="minmax(auto, 2fr) minmax(auto, 1fr)"
            templateAreas="'first second''third third'"
            largePhoneMax={{ templateAreas: "'second second''first first''third third'" }}
        >
            <GridItem area="first">
                <InputField {...creditLimitProps} />
            </GridItem>
            <GridItem area="second">
                <CurrentEnterpriseCurrencySelectField {...currencySelectFieldProps} required />
            </GridItem>
            <GridItem area="third">
                <CreditRatingField />
            </GridItem>
        </Grid>
    </FieldsContainer>
);

export default CreditLimitFields;
